export interface Settings {
  id           : number;
  key          : string;
  value        : string;
  description  : string;
  mutDate     ?: string;
  mutUser     ?: string;
  mutUserName ?: string;
}

export class SettingsCmd {
  id          ?: number;
  key          : string | null = null;
  value        : string | null = null;
  description  : string | null = null;

  public constructor(init?: Partial<SettingsCmd>) {
    Object.assign(this, init);
  }
}
